var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendinvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.5C2 3.11929 3.11929 2 4.5 2H13.5C14.8807 2 16 3.11929 16 4.5V8.03544C15.8367 8.01209 15.6698 8 15.5 8H15V4.5C15 3.67157 14.3284 3 13.5 3H4.5C3.67157 3 3 3.67157 3 4.5V13.5C3 14.3284 3.67157 15 4.5 15H6V15.5C6 15.6698 6.01209 15.8367 6.03544 16H4.5C3.11929 16 2 14.8807 2 13.5V4.5ZM13 7.5C13 7.77614 12.7761 8 12.5 8H7.5C7.22386 8 7 7.77614 7 7.5C7 7.22386 7.22386 7 7.5 7H12.5C12.7761 7 13 7.22386 13 7.5ZM5 5.5C5 5.22386 5.22386 5 5.5 5H12.5C12.7761 5 13 5.22386 13 5.5C13 5.77614 12.7761 6 12.5 6H5.5C5.22386 6 5 5.77614 5 5.5ZM7 11.5C7 10.1193 8.11929 9 9.5 9H15.5C16.8807 9 18 10.1193 18 11.5V15.5C18 16.8807 16.8807 18 15.5 18H9.5C8.11929 18 7 16.8807 7 15.5V11.5ZM9.5 10C8.76327 10 8.15059 10.5311 8.02398 11.2314L12.4999 13.9169L16.976 11.2313C16.8494 10.5311 16.2367 10 15.5 10H9.5ZM8 15.5C8 16.3284 8.67157 17 9.5 17H15.5C16.3284 17 17 16.3284 17 15.5V12.3831L12.7572 14.9288C12.5988 15.0238 12.401 15.0238 12.2427 14.9288L8 12.3832V15.5Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendinvitation);
export default __webpack_public_path__ + "static/media/sendinvitation.477d767af789641ac8ec2c1f3babd743.svg";
export { ForwardRef as ReactComponent };